module.exports = __webpack_public_path__ + "static/media/dog.28ae7ce1.jpg";